import type {
  OrderDetailModel,
  ProductInOrderDetail,
  SubstitutionFlowState,
  ToppingInOrderDetail,
} from 'shared/domain';
import type {
  SelectedItemsOutStock,
  SelectedNodeIds,
} from './substitutionFlow.model';

interface ValidateItemsOutStockProps {
  order: OrderDetailModel;
  selectedNodeIds: SelectedNodeIds;
}

export function validateItemsOutStock(props: ValidateItemsOutStockProps) {
  const { order, selectedNodeIds } = props;
  if (isNaN(order.id)) return { products: [], toppings: [] };
  const products = selectedNodeIds.products
    .map(opID => order.products.find(p => p.orderProductId === opID))
    .filter(p => p !== undefined) as ProductInOrderDetail[];
  const toppings = selectedNodeIds.toppings.map(
    ({ toppingNodeId, orderProductId }) => {
      const product = order.products.find(
        product => product.orderProductId === orderProductId,
      ) as ProductInOrderDetail;
      const topping = product.toppings.find(
        t => t.toppingNodeId === toppingNodeId,
      ) as ToppingInOrderDetail;
      const toppingResult: SelectedItemsOutStock['toppings'][0] = {
        orderProductId: product.orderProductId,
        productId: product.id,
        productName: product.name,
        detail: topping,
      };
      return toppingResult;
    },
  );
  const uniqueProducts = products.filter(
    (product, idx, self) => idx === self.findIndex(p => p.id === product.id),
  );
  const uniqueToppings = toppings.filter(
    (topping, idx, self) =>
      idx === self.findIndex(t => t.detail.id === topping.detail.id),
  );
  return {
    products: uniqueProducts,
    toppings: uniqueToppings,
  } as SelectedItemsOutStock;
}

interface FlowMainStepProps {
  items: SelectedItemsOutStock;
}

export function validateFlowMainStep(props: FlowMainStepProps) {
  const { items } = props;
  let isWithoutItems = true;
  let isMenuItemFinder = false;
  let isMultipleChoice = false;
  const totalItems = items.products.length + items.toppings.length;
  if (totalItems === 1) {
    isWithoutItems = false;
    isMenuItemFinder = true;
  } else if (totalItems >= 2) {
    isWithoutItems = false;
    isMultipleChoice = true;
  }
  return {
    isWithoutItems,
    isMenuItemFinder,
    isMultipleChoice,
  };
}

export function isRemovableItem(
  value: boolean,
  sfState: SubstitutionFlowState | null,
) {
  if (!sfState) return value;
  return (
    value && sfState.status !== 'accepted' && sfState.status !== 'awaiting'
  );
}
